import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';
import { hasTwoHomeCarousels } from './has-two-home-carousels.handle';

export async function ensureSecondCarousel({ list, pharmacy, rootPharmacy, platform, createFn }) {
	if (!hasTwoHomeCarousels(pharmacy, platform)) return list;
	if (!Array.isArray(list) || list.length !== 1) return list;

	const first = list[0];
	const slug = 'home-bottom';
	try {
		const created = await createFn({
			country: Enviroment.COUNTRY,
			tag: slug,
			type: slug,
			editable_name: '',
			products: [],
			status: true,
			images: [],
			page: first.page || 1,
			link_name: first.link_name || pharmacy,
			root_pharmacy: rootPharmacy || first.root_pharmacy || pharmacy,
			section: first.section || 'carousel',
			pharmacy,
			isPageActive: true,
		});
		const second = Array.isArray(created) ? created[0] : created;
		if (!second) return list;
		return [...list, second];
	} catch (e) {
		console.log('ensureSecondCarousel', e);
		return list;
	}
}
